import * as ActionTypes from '../../constants/ActionTypes';
import API from '../../helpers/api';

export function getEquipmentUsageHistory({ id }) {
	return async (dispatch, getState) => {
		dispatch({
			type: ActionTypes.GET_EQUIPMENT_USAGE_HISTORY_REQUEST,
			payload: {
				loading: true
			}
		});

		const response = await API.equipment.getEquipmentUsageHistory({id});
		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.GET_EQUIPMENT_USAGE_HISTORY_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
		}

		dispatch({
			type: ActionTypes.GET_EQUIPMENT_USAGE_HISTORY_SUCCESS,
			payload: {
				loading: false,
				usage_history: response.data.usage_history
			}
		});
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_EQUIPMENT_USAGE_HISTORY_META
		});
	};
}

export function resetPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_EQUIPMENT_USAGE_HISTORY
		});
	};
}
